import { render, staticRenderFns } from "./MatterProgram.vue?vue&type=template&id=7b16bb38&scoped=true"
import script from "./MatterProgram.vue?vue&type=script&lang=js"
export * from "./MatterProgram.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=7b16bb38&prod&scoped=true&lang=css&external"
import style1 from "./MatterProgram.vue?vue&type=style&index=1&id=7b16bb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16bb38",
  null
  
)

export default component.exports